import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

const StyledMessage = styled('p')(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.text.secondary,
}));

const NoTagsMessage = () => (
  <StyledMessage>
    <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.no_tags_message" />
  </StyledMessage>
);

export default NoTagsMessage;
